import { Component, OnInit, Input } from '@angular/core';
import { MitterService } from '../../../services/mitter.service';

@Component({
  selector: 'mitter-channel-event',
  templateUrl: './channel-event.component.html',
  styleUrls: ['./channel-event.component.css']
})
export class ChannelEventComponent implements OnInit {
  @Input() channelEvent: any;

  constructor(private mitterService: MitterService) {}

  ngOnInit() {}

  getChannelEventText() {
    if (this.channelEvent.type === 'com.petcart.channel.JoinChannel') {
      if (this.channelEvent.subject.identifier === this.mitterService.mitter.getUserId()) {
        return 'You joined';
      } else {
        return 'Patient joined';
      }
    } else {
      return 'Somebody joined chat';
    }
  }
}
